<template>
  <div class="flex flex-col items-center justify-center h-96">
    <svg
      v-if="variant === 'search'"
      class="w-16 h-16 text-gray-500 mb-4"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="10.5" cy="10.5" r="6.5" stroke="currentColor" stroke-width="2.25" />
      <path d="M15.5 15.5 20 20" stroke="currentColor" stroke-width="2.25" stroke-linecap="round" />
    </svg>
    <svg v-else class="w-12 h-12 text-gray-500 mb-3" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M4 9l4.5-4.5L12 8l4-4 4 4" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M5 13v7M10 15v5M15 12v8M20 15v5" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
    </svg>
    <h4 class="mb-1 text-lg font-bold text-gray-900">{{ title || content.title }}</h4>
    <p class="mb-0 text-sm text-gray-500">{{ description || content.description }}</p>
  </div>
</template>

<script>
const CONTENT = {
  empty: {
    title: 'No Data Yet',
    description: 'There is no information to display right now',
  },
  search: {
    title: 'No results found',
    description: "We couldn't find anything matching your search. Try different keywords or check your spelling.",
  },
};

export default {
  name: 'InsightEmptyState',
  props: {
    variant: {
      type: String,
      default: 'empty',
      validator: (value) => Object.keys(CONTENT).includes(value),
    },
    title: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
  },
  computed: {
    content() {
      return CONTENT[this.variant];
    },
  },
};
</script>
